import { AfterViewInit, Component, Inject } from "@angular/core";
import { AdaptCommonDialogService } from "@common/ux/adapt-common-dialog/adapt-common-dialog.service";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { ContentReadyEvent, HidingEvent } from "devextreme/ui/popover";
import { debounceTime, filter, finalize, Subject, takeUntil, tap } from "rxjs";
import { CHAT_AI_ORG_PROVIDER, IChatAiOrgProvider, IMegaPromptLabel } from "../chat-ai-org-provider.interface";
import { ChatAiStickyDialogComponent } from "../chat-ai-sticky-dialog/chat-ai-sticky-dialog.component";
import { ChatAiUiService, ChatLocationMode } from "../chat-ai-ui.service";

@Component({
    selector: "adapt-chat-ai-application-bar-item",
    standalone: false,
    templateUrl: "./chat-ai-application-bar-item.component.html",
    styleUrl: "./chat-ai-application-bar-item.component.scss",
})
export class ChatAiApplicationBarItemComponent extends BaseComponent implements AfterViewInit {
    public dialogSpawn = false;
    public applicableMegaPromptLabels: IMegaPromptLabel[] = [];
    public popoverVisible = false;
    public popoverCancelHiding = false;

    public pulseMegaPrompt = false;
    private triggerMegaPromptPulse$ = new Subject<boolean>();

    public constructor(
        private readonly DialogService: AdaptCommonDialogService,
        @Inject(CHAT_AI_ORG_PROVIDER) private orgService: IChatAiOrgProvider,
        private chatUiService: ChatAiUiService,
    ) {
        super();

        this.triggerMegaPromptPulse$.pipe(
            filter((trigger) => trigger), // only pulse if we have prompts to show
            tap(() => this.pulseMegaPrompt = true),
            debounceTime(3000),
            this.takeUntilDestroyed(),
        ).subscribe(() => this.pulseMegaPrompt = false);
    }

    public ngAfterViewInit() {
        this.chatUiService.isFeatureEnabledForLocationMode$(ChatLocationMode.ApplicationBarDialog).pipe(
            this.takeUntilDestroyed(),
        ).subscribe((isAppBarDialogEnabled) => {
            if (isAppBarDialogEnabled && this.chatUiService.isSwitchingLocationMode) {
                setTimeout(() => this.showChatClient());
            }
        });

        this.chatUiService.applicableMegaPromptLabels$.pipe(
            this.takeUntilDestroyed(),
        ).subscribe((labels) => {
            this.applicableMegaPromptLabels = labels;
            this.triggerMegaPromptPulse$.next(labels.length > 0);
        });
    }

    public showChatClient() {
        if (this.chatUiService.chatLocationMode === ChatLocationMode.Sidebar) {
            this.chatUiService.openSidebar();
        } else if (!this.dialogSpawn) {
            this.dialogSpawn = true;
            this.DialogService.open(ChatAiStickyDialogComponent).pipe(
                takeUntil(this.chatUiService.isFeatureEnabledForLocationMode$(ChatLocationMode.ApplicationBarDialog).pipe(
                    filter((isEnabled) => !isEnabled),
                )),
                takeUntil(this.orgService.organisationSwitching$),
                finalize(() => this.dialogSpawn = false),
            ).subscribe();
        }
    }

    public onPopoverHiding(e: HidingEvent) {
        if (this.popoverCancelHiding) {
            e.cancel = true;
        }
    }

    public onPopoverContentReady(e: ContentReadyEvent) {
        const content = e.component.content() as unknown as JQuery<HTMLElement>;
        content.on("dxpointerleave", () => { this.popoverVisible = false; this.popoverCancelHiding = false; });
        content.on("dxpointerenter", () => this.popoverCancelHiding = true);
    }

    public onMegaPromptItemClick(e: { itemData?: IMegaPromptLabel }) {
        this.popoverCancelHiding = false;
        this.popoverVisible = false;
        if (e.itemData?.promptName) {
            this.showChatClient();
            this.chatUiService.queueMegaPromptExecution(e.itemData);
        }
    }

}

